import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;


`

export const ForcePasswordContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ContainerLabel = styled.div`
  height: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`

export const Label = styled.label`
  width: 35%;
  height: 100%;
  border-radius: 14px;
  margin-top: 20px;
`
